export const clamp = (value: number, min: number, max: number): number => {
  return Math.min(Math.max(value, min), max);
};

export const scale = (proportion: number, min: number, max: number): number => {
  return min + proportion * (max - min);
};
